import { HUBFARM_COLORS } from '../hubfarmThemeConf';
export const hubfarmSentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${HUBFARM_COLORS.primary.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${HUBFARM_COLORS.primary.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${HUBFARM_COLORS.primary.main} !important`,
    },
};
//# sourceMappingURL=hubfarmSentryReportStyle.js.map